import supabase from "./Supabase";

export async function getAllTags(): Promise<string[]> {
    const [{ data: allData }, { data: parentData }] = await Promise.all([
        supabase.from('tags').select('tag_id, name').order('name'),
        supabase.from('tags').select('parent_id').not('parent_id', 'is', null),
    ]);
    if (!allData) return [];
    const folderIds = new Set((parentData || []).map((r: any) => r.parent_id));
    return allData.filter((t: any) => !folderIds.has(t.tag_id)).map((t: any) => t.name);
}

export async function getTagFolders(): Promise<{ id: number; name: string; tags: string[] }[]> {
    const [{ data: folders }, { data: children }] = await Promise.all([
        supabase.from('tags').select('tag_id, name').is('parent_id', null).order('name'),
        supabase.from('tags').select('name, parent_id').not('parent_id', 'is', null).order('name'),
    ]);
    if (!folders) return [];
    const childList = children || [];
    const folderIds = new Set(childList.map((c: any) => c.parent_id));
    return (folders as any[])
        .filter(f => folderIds.has(f.tag_id))
        .map(f => ({
            id: f.tag_id as number,
            name: f.name as string,
            tags: childList.filter((c: any) => c.parent_id === f.tag_id).map((c: any) => c.name as string),
        }));
}

export async function populateListsFromView(lists: string[]) {
    const { data, error } = await supabase
        .from("list_values")
        .select("*")
        .in("list_type", lists);

    if (error) {
        console.error("Error fetching list values:", error);
        return {};
    }

    // Transform the data into an object with list_type as keys and values as arrays
    const dataObject = data?.reduce((acc, item) => {
        if (!acc[item.list_type]) {
            acc[item.list_type] = item.values;
        }
        return acc;
    }, {} as { [key: string]: string[] });

    return dataObject ?? {};
}

export async function getDateRangesFromView() {
    const { data, error } = await supabase
        .from("date_ranges")
        .select("*")

    if (error) {
        console.error("Error fetching date ranges:", error);
        return {};
    }

    // Transform the data into an object with list_type as keys and values as arrays
    const dataObject = data?.reduce((acc, item) => {
        if (!acc[item.field_name]) {
            acc[item.field_name] = [item.min_date, item.max_date];
        }
        return acc;
    }, {} as { [key: string]: string[] });

    return dataObject ?? {};

}